import { fetchWikipediaData } from "features/CategoryNews/services/wikipedia.service";
import { searchConfig } from "config";

const createWikiAdapter = ({ searchContext, user }) => {
  const { currentSearchTerm } = searchContext;

  const pageSize = searchConfig.wiki.count;
  const enabled = Boolean(currentSearchTerm);
  const dependencies = [currentSearchTerm];

  const fetchPage = async (cursor) => {
    if (!enabled) return { items: [], nextCursor: cursor, hasMore: false };
    const data = await fetchWikipediaData(currentSearchTerm, user, cursor, pageSize);
    const items = data?.data?.webPages?.value || [];
    const total = data?.data?.webPages?.totalEstimatedMatches || 0;
    const nextCursor = cursor + pageSize;
    const hasMore = nextCursor < total;
    return { items, nextCursor, hasMore };
  };

  return {
    idKey: "url",
    initialCursor: 0,
    fetchPage,
    dependencies,
    enabled,
    isPageMode: false,
  };
};

export default createWikiAdapter;


